var debounce = require('lodash.debounce');

(function ($) {
	function createAutoComplete($searchInput) {
		var KEY_CODES = {
			ESC: 27,
			UP: 38,
			DOWN: 40
		};

		var $result;
		var $form;
		var hasResults = false;
		var selectedResultIndex = -1;
		var ongoingRequest;

		function init() {
			var labelResults = 'S&ouml;kresultat:';
			var labelNoResults = 'Inget resultat';
			var $lang = $('html').attr('lang');

			$form = $searchInput.parents('form');

			if ($lang === undefined || '') { $lang = 'en';}

			$searchInput.on('input', debounce(function () {
				handleSearchInput.call(this);
			}, 250));

			if ($lang === 'en') {
				labelResults = 'Searchresults';
				labelNoResults = 'No search results';
			}

			$form.append('<ul class="autocomplete-results" role="listbox" tabindex="0" lang="' +
				$lang + '" aria-label="' + labelResults + '">' +
				'<li class="autocomplete-results__hit" role="option" aria-selected="false" lang="' +
				$lang + '">' + labelNoResults + '</li></ul>');

			$result = $form.find('.autocomplete-results');

			$result.on('click', '.autocomplete-results__hit', function () {
				var $this = $(this);
				$searchInput.val(getInputText($this));
				closeResults();
				$form.submit();
			});

			$form.on('submit', function() {
				closeResults();
			});

			$(window).on('keydown', handleKeyDown);

			$('body').on('click', closeResultsOnClickOutside);
		}

		function handleKeyDown(e) {
			var keyCode = e.keyCode;

			if (shouldHandleKeyDown(keyCode) === false) {
				return;
			}

			var $results = $result.find('.autocomplete-results__hit');

			var markSearchResult = function () {
				e.preventDefault();

				$results.removeClass('active');
				$results.attr('aria-selected', 'false');

				var $activeResult = $($results[selectedResultIndex]);
				$activeResult.addClass('active');
				$activeResult.attr('aria-selected', 'true');
				$searchInput.val(getInputText($activeResult));

				var idOfSelected = $activeResult.attr('id');
				$result.attr('aria-activedescendant', idOfSelected);
			};

			switch (keyCode) {
				case KEY_CODES.ESC:
					revertSearchTerm();
					closeResults();
					break;
				case KEY_CODES.UP:
					handleUpKey($results);
					break;
				case KEY_CODES.DOWN:
					handleDownKey($results);
					break;
			}

			markSearchResult();
		}

		function handleUpKey($results) {
			if (resultsAreShown() === false) {
				showResults();
			} else if (selectedResultIndex > -1) {
				selectedResultIndex--;
			} else if (selectedResultIndex === -1) {
				selectedResultIndex = $results.length - 1;
			}
		}

		function handleDownKey($results) {
			if (resultsAreShown() === false) {
				showResults();
			} else if (selectedResultIndex < $results.length - 1) {
				selectedResultIndex++;
			} else if (selectedResultIndex === $results.length - 1) {
				selectedResultIndex = -1;
			}
		}

		function shouldHandleKeyDown(keyCode) {
			var shouldHandleKey = Object.keys(KEY_CODES).some(function (keyCodeToHandle) {
				return KEY_CODES[keyCodeToHandle] === keyCode;
			});

			if (hasResults === false || shouldHandleKey === false) {
				return false;
			}

			var $results = $result.find('.autocomplete-results__hit');

			if ($searchInput.is(':focus') === false && $results.is(':focus') === false) {
				return false;
			}
		}

		function closeResultsOnClickOutside(e) {
			if (hasResults === false) {
				return;
			}

			var $target = $(e.target);

			if ($form.has($target).length === 0) {
				revertSearchTerm();
				closeResults();
			}
		}

		function handleSearchInput() {
			var searchTerm = $(this).val().toLowerCase().trim();
			hasResults = false;

			if (searchTerm.length < 3) {
				$result.removeClass('autocomplete-results--open');
				return;
			}

			$(this).data('search-term', searchTerm);

			getResults(searchTerm, function (hits) {
				hasResults = hits.length > 0;
				selectedResultIndex = -1;
				$result.find('li').remove();
				$result.append(renderResultHtml(hits, searchTerm));
				showResults();
			});
		}

		function revertSearchTerm() {
			$searchInput.val(getInputText(null));
		}

		function resultsAreShown() {
			return $result.hasClass('autocomplete-results--open');
		}

		function closeResults() {
			$result.removeClass('autocomplete-results--open');
			selectedResultIndex = -1;
		}

		function showLoadingIndicator() {
			var html = [
				'<li class="autocomplete-results__loading-indicator">',
				'<img src="/Content/images/spinner.png" alt="" />',
				'</li>'
			].join('');
			$result.find('li').remove();
			$result.append(html);
			showResults();
		}

		function hideLoadingIndicator() {
			$result.find('li').remove();
			closeResults();
		}

		function showResults() {
			if ($searchInput.parents('.page-base__main__body').length > 0) {
				var inputOffset = $searchInput.offset();
				$result.css({
					'left': inputOffset.left,
					'top': inputOffset.top + $searchInput.outerHeight()
				});
			}

			$result.addClass('autocomplete-results--open');
		}

		function renderResultHtml(hits, searchTerm) {
			var highlightSearchTerm = function (hit) {
				return hit.replace(new RegExp(searchTerm, 'ig'), '<strong>$&</strong>');
			};

			var hitsHtml = hits.map(function (hit, index) {
				return [
					'<li class="autocomplete-results__hit" role="option" id="search-results-' +
					index + '" aria-selected="false">' + 
					highlightSearchTerm(hit),
					'</li>'
				].join('');
			}).join('');

			return hitsHtml;
		}

		function getResults(searchTerm, doneCallback) {
			var aborted = false;

			if (ongoingRequest && ongoingRequest.readyState !== 4) {
				ongoingRequest.abort();
				aborted = true;
			}

			showLoadingIndicator();

			ongoingRequest = $.ajax({
				url: '/find_v2/_autocomplete',
				type: 'GET',
				data: {
					prefix: searchTerm,
					size: 10
				},
				success: function (data) {
					var hits = data.hits.map(function (hit) {
						return hit.query;
					});

					return doneCallback(hits);
				},
				error: function () {
					if (aborted === false) {
						hideLoadingIndicator();
					}
				}
			});
		}

		function getInputText($activeResult) {
			if ($activeResult === null || $activeResult.length === 0) {
				return $searchInput.data('search-term');
			} else {
				return $activeResult.text();
			}
		}

		init();
	}


	$('.js-autocomplete').each(function() {
		createAutoComplete($(this));
	});
})(jQuery);
